var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-progress-bar-widget"},[_c('vue-slider',{attrs:{"interval":_vm.step,"min":_vm.min,"max":_vm.max,"value":_vm.value},on:{"change":_vm.onChangeProgress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }